import { ThemeData, ThemesState } from '../../reducer';

const THEME_REG_EXP = /\/\* webPublication-theme[\s\S]*? BEGIN[\s\S]*?webPublication-theme END \*\//gm;
const THEME_ID_REG_EXP = /id\:(\d+);/;
const THEME_NAME_REG_EXP = /name\:([\s\S]*?);/;
const THEME_COLOR_VALUE_REG_EXP = /rgba\(.*\)/g;

export const getThemesAndSelectedThemeId = (css: string): {
	themes: ThemesState | null;
	selectedThemeId: string | null;
} => {
	const themesMatch = css.match(THEME_REG_EXP);

	if (!themesMatch) {
		return {
			themes: null,
			selectedThemeId: null,
		};
	}

	const themes = {};
	let selectedThemeId: string | null = null;

	themesMatch.forEach((themeMatch) => {
		const themeIdMatch = themeMatch.match(THEME_ID_REG_EXP);
		const themeNameMatch = themeMatch.match(THEME_NAME_REG_EXP);
		const themeColorValuesMatch = themeMatch.match(THEME_COLOR_VALUE_REG_EXP);

		if (themeIdMatch && themeNameMatch && themeColorValuesMatch) {
			const id = themeIdMatch[1];
			themes[id] = {
				id,
				name: themeNameMatch[1],
				colors: themeColorValuesMatch,
			};

			if (themeMatch.includes('!important')) {
				selectedThemeId = id;
			}
		}
	});

	return {
		themes,
		selectedThemeId,
	};
};

export const getCssWithUpdatedThemes = (css: string, themeId: string): string => {
	return css.replace(THEME_REG_EXP, (themeMatch) => {
		return themeMatch.includes(themeId)
			? themeMatch.replace(/\)\;/g, '\)\ !important;')
			: themeMatch.replace(/ !important;/g, '\;');
	});
};

const getThemeByIdRegExp = (id: string) => new RegExp(`\\/\\* webPublication-theme id:${id}[\\s\\S]*? BEGIN[\\s\\S]*?webPublication-theme END \\*\\/`, 'gm');

export const getCssWithDuplicatedTheme = (css: string, sourceThemeId: string, { id, name }: ThemeData): string => {
	const sourceThemeDataRegExp = getThemeByIdRegExp(sourceThemeId);
	const sourceThemeData = css.match(sourceThemeDataRegExp);

	if (!sourceThemeData) {
		return css;
	}

	const newThemeData = sourceThemeData[0]
		.replace(THEME_ID_REG_EXP, (idMatch, sourceThemeId) => {
			return idMatch.replace(sourceThemeId, id);
		})
		.replace(THEME_NAME_REG_EXP, (nameMatch, sourceThemeName) => {
			return nameMatch.replace(sourceThemeName, name);
		});

	return css.replace(THEME_REG_EXP, (themeMatch) => {
		return themeMatch.replace(/ !important;/g, '\;');
	}) + `\n${newThemeData}`;
};

export const getCssWithoutRemovedTheme = (css: string, themeId: string, newSelectedThemeId: string): string => {
	const themesMatch = css.match(THEME_REG_EXP);

	if (!themesMatch) {
		return css;
	}

	const themeToRemove = themesMatch.find(themeMatch => themeMatch.includes(themeId));

	if (!themeToRemove) {
		return css;
	}

	const cssWithoutRemovedTheme = css.replace(themeToRemove, '');

	return getCssWithUpdatedThemes(cssWithoutRemovedTheme, newSelectedThemeId).trim();
};

export const getCssWithRenamedTheme = (css: string, themeId: string, themeName: string): string => {
	return css.replace(THEME_REG_EXP, (themeMatch) => {
		if (themeMatch.includes(themeId)) {
			const themeNameMatch = themeMatch.match(THEME_NAME_REG_EXP);
			return themeNameMatch
				? themeMatch.replace(themeNameMatch[0], `name:${themeName};`)
				: themeMatch;
		}

		return themeMatch;
	});
};

export const getCssWithUpdatedThemeColor = (css: string, themeId: string, colorIndex: number, colorValue: string): string => {
	return css.replace(THEME_REG_EXP, (themeMatch) => {
		if (themeMatch.includes(themeId)) {
			const themeColorRegExp = new RegExp(`\\[class\\*="webPublication-theme-color-${colorIndex}"\\][\\s\\S]*?{[\\s\\S]*?}`, 'g');
			const themeColorMatch = themeMatch.match(themeColorRegExp);

			return themeColorMatch
				? themeMatch.replace(themeColorMatch[0], (str) => (
					str.replace(THEME_COLOR_VALUE_REG_EXP, colorValue)
				))
				: themeMatch;
		}

		return themeMatch;
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/themesCss.ts